function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, canUpdateBilling, credited, eligible, encodeURIComponent, incubator, initialValue, loggedIn, nextUrl, pastExpiry, showOther) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['logo-img'] = function(metadata) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("img", {
          "attrs": __vjadeStringifyAttrsIfObj(metadata),
        }));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['fields'] = function(tfbf) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'auth-form-field-row': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'referral-partner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'referral-partner': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Referral Partner");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'parenthetical': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("(VC, Incubator, Accelerator, or Marketplace)");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'info-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `info`
                }),
                "class": {
                  'info-icon': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  placement: `top`
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Select 'Other' to enter a partner not listed or 'I do not have a referral partner' if you were not referred.");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": __vjadeStringifyAttrsIfObj({
              options: JSON.stringify($helpers.REFERRAL_INCUBATORS),
              'selected-option': incubator,
              'label-transform': `uppercase`,
              tabindex: 0,
              disabled: tfbf,
            }),
            "on": {
              change: $helpers.updateReferralIncubator
            },
          }));
          __jade_nodes = __jade_nodes.concat((showOther) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'other-input-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'field-id': `id_otherIncubator`,
                  'field-name': `otherIncubator`,
                  label: `Provide Your Referral Partner`,
                }),
                "on": {
                  input: $helpers.handleOtherInput
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const brandButtonStyle = require('./marketing-button.inline.styl');;
    const pyramid = require('./pyramid.svg');;
    const {
      MP_LOGO_METADATA,
      MP2023_LOGO_METADATA
    } = require('../constants');;
    return {
      value: (h("div", (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((credited && !pastExpiry) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'success-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'left-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'success-header': true
                },
              }, [__vjadeSafeCode(`You're almost there...`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'steps': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'step-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                    "class": {
                      'checkmark': true
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat("Apply to the Mixpanel Startups Program");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("hr", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    width: '1px',
                    size: '30px'
                  }),
                  "class": {
                    'vertical-line': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'step-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                    "class": {
                      'checkmark': true
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat("🎉 $" + ($helpers.commaize(initialValue)) + " in credits granted");
                  __jade_nodes = __jade_nodes.concat(($helpers.getOrgName()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(" to " + ($helpers.getOrgName()) + " 🎉");;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("hr", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    width: '1px',
                    size: '30px'
                  }),
                  "class": {
                    'vertical-line': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'step-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle'
                    }),
                    "class": {
                      'checkmark': true
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat("Purchase a plan and your credits will apply automatically");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`
                }),
                "on": {
                  click: $helpers.clickPlanBuilder
                },
                "class": {
                  'success-button': true
                },
                "props": {
                  id: 'plan-builder-button'
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Purchase Your Growth Plan ");
                  __jade_nodes = __jade_nodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        icon: 'arrow-right'
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this));
                  __jade_nodes = __jade_nodes.concat("");;
                  return __jade_nodes
                }).call(this));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'right-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("img", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  src: pyramid
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'auth-form': true,
              'startups-form': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'left-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'program-info': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "props": {
                    id: 'logo-header'
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      href: '/'
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("img", {
                      "attrs": __vjadeStringifyAttrsIfObj($attr('mp23-brand') ? MP2023_LOGO_METADATA : MP_LOGO_METADATA),
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat((!$attr('mp23-brand')) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'apply': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'icon': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'dashboard'
                        }),
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Apply");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'startups-header': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Startup Program");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'details-text': true,
                    'purple-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Why Join?");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'info-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'info-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Get real-time insight into your top product questions.");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'info-row': true,
                    'last': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'info-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Convert, engage, and retain more users.");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'info-row': true,
                    'last': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'info-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Nail your product-market fit.");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'details-text': true,
                    'purple-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("What are the details?");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'info-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'info-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Eligible startups get $50,000 in credits towards the Mixpanel Growth plan for one year.");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'info-row': true,
                    'last': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: 'circle-checkmark'
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'info-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("The credits cover the costs for the plan you purchase and any add-ons.");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'info-row': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'info-text': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("");
                        __jade_nodes = __jade_nodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("a", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              href: 'https://help.mixpanel.com/hc/en-us/articles/360043474691-Mixpanel-s-Startup-Program',
                              class: `faq-link`
                            }),
                            "style": {
                              'text-decoration': 'underline'
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Check out our FAQ");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                        __jade_nodes = __jade_nodes.concat(" for more information");;
                        return __jade_nodes
                      }).call(this));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'form-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("form", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  id: `mpStartupsApply`,
                  method: `post`,
                  action: `/startups-apply/?incubator=${encodeURIComponent($helpers.getIncubator())}&next=${nextUrl}`,
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((eligible) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("h1", {
                    "class": {
                      'auth-form-title': true
                    },
                  }, [__vjadeSafeCode(`Let's Get Started`)]));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'auth-form-field-content': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(($helpers.isTFBF()) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'subheading': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Tech for Black Founders");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("p", (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Your startup will receive $50,000 in Mixpanel credits towards a growth plan, which you can use for a full year.");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'subheading': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Eligibility Requirements");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'checkmark'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Have raised less than $30M in total funding");
                      __jade_nodes = __jade_nodes.concat(h("br"));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'checkmark'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Employ fewer than 150 people");
                      __jade_nodes = __jade_nodes.concat(h("br"));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'checkmark'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Not already a paying customer");
                      __jade_nodes = __jade_nodes.concat(h("br"));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'checkmark'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Led by one or more Black founders");;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'subheading': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Eligibility Requirements");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'status-light'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Not currently a paying Mixpanel customer");
                      __jade_nodes = __jade_nodes.concat(h("br"));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'status-light'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Founded less than 5 years ago");
                      __jade_nodes = __jade_nodes.concat(h("br"));
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: 'status-light'
                        }),
                        "class": {
                          'checkmark': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat("Raised up to $8M in total funding");;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean))); /*  We use the attr here because it disables changing your incubator */
                  __jade_nodes = __jade_nodes.concat(jade_mixins['fields'].call(this, $attr(`tech-for-black-founders`)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'auth-form-field-row': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        disabled: $helpers.continueButtonDisabled(),
                        size: `large`,
                        theme: `primary`
                      }),
                      "on": {
                        click: $helpers.continueButtonClicked
                      },
                      "class": {
                        'auth-form-field-action-button': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Sign Me Up!");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("h1", {
                    "class": {
                      'auth-form-title': true
                    },
                  }, [__vjadeSafeCode(`Sorry! You aren't eligible`)]));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'auth-form-field-content': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((pastExpiry) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("p", (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Your credits have expired as of " + ($attr(`expiration`)) + ". Have questions? ");
                          __jade_nodes = __jade_nodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("a", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                href: 'https://mixpanel.com/get-support',
                                target: '_blank'
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("Contact support");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                          __jade_nodes = __jade_nodes.concat(".");;
                          return __jade_nodes
                        }).call(this));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : (canUpdateBilling) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("p", (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("This plan is for new customers that aren't currently on a paid plan.");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("p", (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Please contact your organization's billing admin or owner to change your plan.");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)));
                    __jade_nodes = __jade_nodes.concat(h("a", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        href: `/`
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          size: `large`,
                          theme: `primary`
                        }),
                        "class": {
                          'auth-form-field-action-button': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Back To Mixpanel");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));
                __jade_nodes = __jade_nodes.concat((!loggedIn) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(($helpers.isTFBF()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'auth-form-field-row': true
                      },
                      "props": {
                        id: 'last-row'
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Already using Mixpanel? ");
                        __jade_nodes = __jade_nodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("a", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              href: `/login/?next=/startups-apply-tfbf/`,
                              class: `mp-link`
                            }),
                            "style": {
                              'padding-left': `5px`
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Log in");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                        __jade_nodes = __jade_nodes.concat("");;
                        return __jade_nodes
                      }).call(this));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'auth-form-field-row': true
                      },
                      "props": {
                        id: 'last-row'
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Already using Mixpanel? ");
                        __jade_nodes = __jade_nodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("a", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              href: `/login/?next=/startups-apply/`,
                              class: `mp-link`
                            }),
                            "style": {
                              'padding-left': `5px`
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Log in");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                        __jade_nodes = __jade_nodes.concat("");;
                        return __jade_nodes
                      }).call(this));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'free-plan-text': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Or, try the");
                  __jade_nodes = __jade_nodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("a", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        class: `free-plan-link`
                      }),
                      "style": {
                        'padding-left': `5px`
                      },
                      "on": {
                        click: $helpers.clickFreePlan
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Free plan first");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                  __jade_nodes = __jade_nodes.concat("");;
                  return __jade_nodes
                }).call(this));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "canUpdateBilling" in locals ? locals.canUpdateBilling : typeof canUpdateBilling !== "undefined" ? canUpdateBilling : undefined, "credited" in locals ? locals.credited : typeof credited !== "undefined" ? credited : undefined, "eligible" in locals ? locals.eligible : typeof eligible !== "undefined" ? eligible : undefined, "encodeURIComponent" in locals ? locals.encodeURIComponent : typeof encodeURIComponent !== "undefined" ? encodeURIComponent : undefined, "incubator" in locals ? locals.incubator : typeof incubator !== "undefined" ? incubator : undefined, "initialValue" in locals ? locals.initialValue : typeof initialValue !== "undefined" ? initialValue : undefined, "loggedIn" in locals ? locals.loggedIn : typeof loggedIn !== "undefined" ? loggedIn : undefined, "nextUrl" in locals ? locals.nextUrl : typeof nextUrl !== "undefined" ? nextUrl : undefined, "pastExpiry" in locals ? locals.pastExpiry : typeof pastExpiry !== "undefined" ? pastExpiry : undefined, "showOther" in locals ? locals.showOther : typeof showOther !== "undefined" ? showOther : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;